import { useState, createContext } from "react";


export const WalletContext = createContext()

export const WallerProvider=({children})=>
{
    const [walletAddress,setWalletAddress]=useState('')
    const [provider,setProvider]=useState('')
    const [auth,setAuth]=useState('')
    const [EGBXbal,setEGBXbal]=useState('')
    const [GDBXbal,setGDBXbal]=useState('')
    
    return(
            <WalletContext.Provider value={{walletAddress,setWalletAddress,provider,setProvider,auth,setAuth,EGBXbal,GDBXbal,setEGBXbal,setGDBXbal}}>
                  {children}
            </WalletContext.Provider>
        )
}
